import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import './style.css';

const CustomScrollbar = ({ children, ...restProps }) => {
  return <PerfectScrollbar {...restProps}>{children}</PerfectScrollbar>;
};

export default CustomScrollbar;
